import React from "react";
import circleText from "../../assets/img/home_1/UNepal-text_dark.webp";
import { useHashScroll } from "../../hooks/custom/useHashScroll";
import {
  IAboutIntroductionData,
  IAboutJoinUsData,
  IAboutWhoUnepalForData,
  IAboutWhyUnepalData,
} from "../../exports/interfaces";
import Offcanvas from "bootstrap/js/dist/offcanvas";

export const Introduction = (props: {
  aboutIntroduction: IAboutIntroductionData[];
  aboutWhyUnepal: IAboutWhyUnepalData[];
  aboutWhoUnepalFor: IAboutWhoUnepalForData[];
  aboutJoinUs: IAboutJoinUsData[];
}) => {
  useHashScroll(120);

  const openAdsDrawer = () => {
    const el = document.getElementById("offcanvasRight");

    if (el) {
      const offcanvas = new Offcanvas(el);
      offcanvas.show();
    }
  };

  return (
    <section id="our-story">
      <div className="td_height_120 td_height_lg_40" />
      <div className="td_about td_style_1">
        <div className="container">
          <div
            className="td_section_heading td_style_1 text-center wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.15s"
          >
            <h2 className="td_section_title td_fs_48 mb-0">About</h2>
            <div className="td_height_30 td_height_lg_30" />
          </div>

          <div className="row td_gap_y_40 td_mb_50">
            <div
              className="col-lg-6 wow fadeInLeft"
              data-wow-duration="1s"
              data-wow-delay="0.25s"
            >
              <div className="td_about_thumb_wrap">
                {/* <div className="td_about_year text-uppercase td_fs_64 td_bold">
                  EST 2024
                </div> */}
                <div className="td_about_thumb_1">
                  <img
                    src={`${process.env.REACT_APP_cmsUrl}${props?.aboutIntroduction[0]?.image_1[0]?.media?.url}`}
                    alt="About"
                  />
                </div>
                <div className="td_about_thumb_2">
                  <img
                    src={`${process.env.REACT_APP_cmsUrl}${props?.aboutIntroduction[0]?.image_2[0]?.media?.url}`}
                    alt="About"
                  />
                </div>

                <button
                  onClick={openAdsDrawer}
                  className="td_circle_text td_center td_video_open"
                >
                  <svg
                    width="15"
                    height="19"
                    viewBox="0 0 15 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.086 8.63792C14.6603 9.03557 14.6603 9.88459 14.086 10.2822L2.54766 18.2711C1.88444 18.7303 0.978418 18.2557 0.978418 17.449L0.978418 1.47118C0.978418 0.664496 1.88444 0.189811 2.54767 0.649016L14.086 8.63792Z"
                      fill="#2f2b75"
                    />
                  </svg>{" "}
                  <img src={circleText} alt="Circle Logo" />
                </button>
              </div>
            </div>

            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-duration="1s"
              data-wow-delay="0.3s"
            >
              <div className="td_section_heading td_style_1 td_mb_30">
                <h2 className="td_section_title td_fs_24 mb-2">Introduction</h2>
                <p
                  className="td_section_subtitle td_fs_18 mb-0"
                  style={{ marginTop: 0 }}
                  dangerouslySetInnerHTML={{
                    __html: props?.aboutIntroduction[0]?.description,
                  }}
                />
              </div>
            </div>
          </div>

          <div>
            <section id="why-unepal">
              <div className="td_mb_30">
                <h2 className="td_section_title td_fs_24 mb-2">Why UNepal? </h2>
                <p className="td_section_subtitle td_fs_18 mb-0">
                  <ul>
                    {props?.aboutWhyUnepal?.map((item) => {
                      return (
                        <li>
                          <b>{item?.title}: </b>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: item?.description,
                            }}
                          />
                        </li>
                      );
                    })}
                  </ul>
                </p>
              </div>
            </section>

            {/* <div className="td_mb_30">
              <h2 className="td_section_title td_fs_24 mb-2">
                Undergraduate Studies
              </h2>
              <p className="td_section_subtitle td_fs_18 mb-0">
                Our undergraduate programs are built on a Liberal Arts, Sciences
                & Technology (LAS&T) foundation. Students gain broad knowledge
                across disciplines while exploring their interests and shaping a
                major.
              </p>
            </div>

            <div className="td_mb_30">
              <h2 className="td_section_title td_fs_24 mb-2">
                Graduate Studies
              </h2>
              <p className="td_section_subtitle td_fs_18 mb-0">
                Our graduate programs are designed for advanced learning,
                research and professional growth. These programs combine global
                knowledge with Nepal’s unique context, preparing leaders for
                academic & civic success.
              </p>
            </div> */}

            <div className="td_mb_30">
              <h2 className="td_section_title td_fs_24 mb-2">
                Who is UNepal for?
              </h2>
              <p className="td_section_subtitle td_fs_18 mb-0">
                <ul>
                  {props?.aboutWhoUnepalFor?.map((item) => {
                    return (
                      <li>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item?.description,
                          }}
                        />
                      </li>
                    );
                  })}
                </ul>
              </p>
            </div>

            <div className="td_mb_30">
              <h2 className="td_section_title td_fs_24 mb-2">
                Join Us in Building Nepal's Future
              </h2>
              <p
                className="td_section_subtitle td_fs_18 mb-3"
                dangerouslySetInnerHTML={{
                  __html: props?.aboutJoinUs[0]?.description,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
